import { AbstractControl, ValidationErrors } from '@angular/forms';

export class FileValidators {
  public static filenameEndsWithPdf(fileFormControl: AbstractControl): ValidationErrors | null {
    let validationResult: ValidationErrors | null;

    const filenameEndsWithPdf: boolean = (/\.pdf$/i).test(fileFormControl.value);

    if (filenameEndsWithPdf) {
      validationResult = null;
    } else {
      validationResult = { validateFile: { valid: false } };
    }

    return validationResult;
  }
}
